import {Component, Vue} from "vue-property-decorator";
import {formatDate} from '@/utils/timeFilter'
import {menuBtn} from '@/utils/menu_level2_button'
import {UserModule} from "@/store/modules/user";
import {getClassesInfoById, updateClasses} from "@/api/classManage";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

@Component({
    components: {
        MoreUsersFilter
    }
})
export default class ClassInfo extends Vue {
    // ------ 变量 ------
    studentInfo = {}
    operationShow = true
    activities = []
    isShow = null
    formModel = {
        name: '', // 班级名称
        code: '', // 班级编号
        teacherUserId: '',
        thesisUserId: '',
        helperUserId: '',
        applyUserId: '',
        // souCourseName: '',
        // souCourseType: '',
        // helperUserRealName: '',
        // thesisUserRealName: '',
        // teacherUserRealName: '',
        remark: ''
    }
    formRules = {
        name: [{required: true, message: '请填写班级名称', trigger: ['blur', 'change']}],
    }
    recordId = ''
    disabledBtn = false
    loading = true

    created() {
        this.recordId = String(this.$route.query.id)
        this.isShow = this.$route.query.isShow

        this.getClassInfo()
    }

   

    buttonShow(id: number): boolean {
        return menuBtn(id)
    }

    formatDate(format: string, val: Date) {
        return formatDate(format, new Date(val))
    }


    getClassInfo() {
        this.loading = true
        getClassesInfoById(this.recordId).then((res: any) => {
            if (this.isShow == 1) {
                this.formModel = res
            } else {
                this.studentInfo = res
                this.activities = res.classesLogList
            }
            this.loading = false

        }).catch(err=>{
            this.loading = false
        })
    }

    doCancelView() {
        window.close()
    }

    //  编辑保存
    handleEditSave() {
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
            }
        });
        const obj = {
            name: this.formModel.name,
            code: this.formModel.code ? this.formModel.code.trim() : '',
            teacherUserId: this.formModel.teacherUserId ? this.formModel.teacherUserId : '',
            thesisUserId: this.formModel.thesisUserId ? this.formModel.thesisUserId : '',
            helperUserId: this.formModel.helperUserId ? this.formModel.helperUserId : '',
            applyUserId: this.formModel.applyUserId ? this.formModel.applyUserId : '',
            remark: this.formModel.remark ? this.formModel.remark : ''
        }
        if (flag) {
            this.disabledBtn = true
            this.loading = true
            updateClasses(this.recordId, obj).then(res => {
                this.$message.success('编辑成功')
                this.disabledBtn = false
                this.loading = false
                setTimeout(() => {
                    window.close()
                })
            }).catch(err => {
                this.disabledBtn = false
                this.loading = false
            })
        }
    }


    changeTeacherUsers(e) {
        this.formModel.teacherUserId = e.id
    }

    changeThesisUsers(e) {
        this.formModel.thesisUserId = e.id
    }

    changeHelperUsers(e) {
        this.formModel.helperUserId = e.id
    }

    changeApplyUserId(e) {
        this.formModel.applyUserId = e.id
    }
}
